module.exports = __webpack_public_path__ + "static/media/user-review.e88622cd.png";